import initialState from './initialState'
import {SET_ERROR_MESSAGE, SET_SUCCESS_MESSAGE} from '../actions/actionTypes'

export default function messages(state = initialState.messages, action) {
    let newState
	switch (action.type) {
        case SET_ERROR_MESSAGE:
        newState = action.messages
		return {
			...newState
		}
    case SET_SUCCESS_MESSAGE:
        newState = action.messages
		return {
			...newState
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/messages.js